import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth debe usarse dentro de AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Verificar token al cargar (buscar en ambos storages)
    useEffect(() => {
        const checkAuth = async () => {
            // Primero intentar localStorage, luego sessionStorage
            let token = localStorage.getItem('token') || sessionStorage.getItem('token');
            if (token) {
                try {
                    const response = await authAPI.getProfile();
                    setUser(response.data);
                } catch (err) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                }
            }
            setLoading(false);
        };
        checkAuth();
    }, []);

    const login = async (email, password, rememberMe = false) => {
        setError(null);
        try {
            const response = await authAPI.login(email, password, rememberMe);
            const { token, user: userData } = response.data;

            // Limpiar ambos storages primero
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');

            // Guardar en el storage correspondiente
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem('token', token);
            storage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('rememberMe', rememberMe.toString());

            setUser(userData);

            return { success: true };
        } catch (err) {
            setError(err.message);
            return { success: false, error: err.message };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('rememberMe');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        setUser(null);
    };

    const refreshUser = async () => {
        try {
            const response = await authAPI.getProfile();
            setUser(response.data);
        } catch (err) {
            // silenciar
        }
    };

    const isAuthenticated = !!user;

    // Helper para verificar permisos
    const tienePermiso = (permiso) => {
        if (!user) return false;
        if (user.rol === 'superadmin') return true;
        return user.permisos?.includes(permiso) || false;
    };

    return (
        <AuthContext.Provider value={{
            user,
            loading,
            error,
            login,
            logout,
            refreshUser,
            isAuthenticated,
            tienePermiso
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
